import { indexItems } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">专题合集</h2>
          <span className="text-xs text-foreground-500 mt-1">共7个合集 · 持续更新</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className="group flex items-start gap-3 p-4 md:p-5 bg-background-100 rounded-lg hover:bg-background-200/70 transition-colors cursor-pointer border border-background-200/60"
            >
              <div className="w-10 h-10 rounded-md bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-lg text-primary-500`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors truncate">{item.title}</h3>
                  {item.tag && (
                    <span className={`flex-shrink-0 px-1.5 py-0.5 rounded text-[10px] font-bold ${item.tag === '爆' ? 'bg-primary-500 text-white' : item.tag === '热' || item.tag === '热榜' ? 'bg-accent-100 text-accent-700' : 'bg-secondary-100 text-secondary-700'}`}>
                      {item.tag}
                    </span>
                  )}
                </div>
                <p className="text-xs text-foreground-500 mt-1 line-clamp-2 leading-relaxed">{item.desc}</p>
                <span className="inline-block mt-2 text-[11px] text-foreground-400">{item.count}条内容</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}